module.exports = __webpack_public_path__ + "static/section1-fg1-4638782f58d6d57f4034a4339820ee9e.png";